var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroPlanet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 454,
    viewBox: "0 0 397 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.442 417.514C308.038 417.514 396.883 328.668 396.883 219.072C396.883 109.476 308.038 20.6305 198.442 20.6305C88.8453 20.6305 0 109.476 0 219.072C0 328.668 88.8453 417.514 198.442 417.514Z",
    fill: "url(#paint0_radial_403_46089)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M198.536 453.598C295.938 453.598 374.899 374.638 374.899 277.235C374.899 179.832 295.938 100.872 198.536 100.872C101.133 100.872 22.1729 179.832 22.1729 277.235C22.1729 374.638 101.133 453.598 198.536 453.598Z",
    fill: "url(#paint1_linear_403_46089)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.256 290.389C297.42 290.389 376.998 225.383 376.998 145.194C376.998 65.0057 297.42 0 199.256 0C101.092 0 21.5142 65.0057 21.5142 145.194C21.5142 225.383 101.092 290.389 199.256 290.389Z",
    fill: "url(#paint2_radial_403_46089)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.524 221.362C247.502 221.362 293.692 183.628 293.692 137.081C293.692 90.5345 247.502 52.8008 190.524 52.8008C133.545 52.8008 87.3552 90.5345 87.3552 137.081C87.3552 183.628 133.545 221.362 190.524 221.362Z",
    fill: "url(#paint3_radial_403_46089)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.091 415.93C275.406 415.93 335.649 355.687 335.649 281.373C335.649 207.058 275.406 146.815 201.091 146.815C126.777 146.815 66.5337 207.058 66.5337 281.373C66.5337 355.687 126.777 415.93 201.091 415.93Z",
    fill: "url(#paint4_linear_403_46089)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M212.546 153.394C212.38 153.94 212.059 154.426 211.623 154.794C210.999 155.295 210.499 155.225 209.199 155.448C207.345 155.839 205.526 156.377 203.758 157.057C203.673 157.057 203.596 157.126 203.519 157.141C203.442 157.157 203.358 157.249 203.411 157.372L203.512 157.603C203.578 157.723 203.61 157.859 203.606 157.996C203.602 158.133 203.562 158.267 203.489 158.383C203.416 158.499 203.313 158.594 203.191 158.657C203.069 158.72 202.933 158.749 202.796 158.742C202.257 158.742 201.718 158.742 201.18 158.742C200.933 158.742 200.841 158.804 200.826 159.065C200.809 159.218 200.736 159.359 200.622 159.461C200.508 159.563 200.36 159.62 200.206 159.62C200.053 159.62 199.905 159.563 199.791 159.461C199.676 159.359 199.604 159.218 199.587 159.065C199.587 158.827 199.494 158.742 199.256 158.75C198.802 158.75 198.348 158.75 197.901 158.75C197.193 158.75 196.901 158.35 197.078 157.665C197.078 157.565 197.078 157.449 197.155 157.349C197.232 157.249 197.155 157.272 197.155 157.195C197.078 156.426 195.208 156.264 193.138 155.887C192.253 155.725 190.929 155.464 189.29 155.048C188.849 154.716 188.484 154.293 188.219 153.809C187.954 153.325 187.794 152.79 187.751 152.239C187.757 151.795 187.849 151.356 188.02 150.947C188.491 149.798 189.295 148.817 190.329 148.13C191.045 147.599 191.776 147.083 192.468 146.522C194.162 145.088 195.26 143.073 195.547 140.873C196.17 137.256 196.778 133.647 197.547 130.061C197.781 129.011 198.098 127.982 198.494 126.983C198.624 126.602 198.879 126.276 199.217 126.059C199.478 125.911 199.772 125.835 200.072 125.836C200.409 125.842 200.737 125.952 201.01 126.151C201.28 126.361 201.479 126.649 201.58 126.975C202.306 128.832 202.862 130.751 203.242 132.708C203.242 132.708 203.704 135.555 204.897 141.643C205.286 143.66 206.421 145.457 208.075 146.675C210.191 148.307 210.33 148.061 211.238 149.177C211.646 149.654 213.131 151.508 212.546 153.394Z",
    fill: "url(#paint5_radial_403_46089)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200.202 125.082C199.072 126.596 198.182 128.276 197.563 130.061C196.662 132.654 196.793 134.455 195.562 140.873C195.3 142.452 194.67 143.947 193.723 145.237C193.347 145.71 192.922 146.141 192.453 146.522C191.76 147.083 191.029 147.599 190.314 148.13C189.28 148.817 188.475 149.798 188.005 150.947C187.852 151.362 187.761 151.798 187.736 152.239C187.695 152.654 187.739 153.072 187.865 153.469C187.99 153.866 188.195 154.233 188.467 154.548C188.701 154.781 188.985 154.957 189.298 155.064C190.555 155.448 191.842 155.729 193.146 155.903C193.146 155.903 197.086 156.434 197.163 157.211C197.174 157.261 197.174 157.314 197.163 157.365C197.04 157.788 195.824 157.488 195.346 158.08C195.202 158.284 195.137 158.533 195.162 158.781H198.063L200.202 125.082Z",
    fill: "url(#paint6_linear_403_46089)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M202.334 158.75H205.197C205.213 158.597 205.193 158.443 205.138 158.3C205.083 158.157 204.995 158.029 204.881 157.926C204.481 157.626 203.765 157.888 203.511 157.588C203.45 157.527 203.414 157.444 203.411 157.357C203.412 157.313 203.422 157.27 203.44 157.23C203.459 157.19 203.486 157.155 203.519 157.126C203.588 157.074 203.671 157.044 203.758 157.041C205.525 156.361 207.345 155.823 209.198 155.433C210.499 155.21 210.999 155.279 211.623 154.779C212.059 154.411 212.38 153.924 212.546 153.378C213.131 151.493 211.646 149.638 211.253 149.161C210.345 148.045 210.207 148.292 208.09 146.66C206.441 145.437 205.307 143.642 204.912 141.627C204.142 138.126 203.534 134.163 203.257 132.693C202.867 130.628 202.29 128.604 201.534 126.644L199.764 125.066L202.334 158.75Z",
    fill: "url(#paint7_linear_403_46089)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M202.673 130.007C202.147 129.871 201.652 129.633 201.218 129.307C200.449 128.722 200.31 128.152 199.895 128.175C199.479 128.198 199.364 128.845 198.563 129.561C198.209 129.883 197.803 130.143 197.363 130.33C197.645 128.904 198.06 127.508 198.602 126.159C199.287 124.458 199.618 124.204 199.895 124.197C200.433 124.197 200.872 125.113 201.434 126.282C201.969 127.48 202.384 128.727 202.673 130.007Z",
    fill: "url(#paint8_linear_403_46089)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M201.611 161.282C201.63 160.972 201.765 160.681 201.989 160.467C202.213 160.253 202.51 160.131 202.82 160.127C203.13 160.122 203.431 160.234 203.662 160.441C203.892 160.648 204.037 160.934 204.065 161.243L202.288 201.26L201.611 161.282Z",
    fill: "url(#paint9_linear_403_46089)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_403_46089",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 159,
    width: 4,
    height: 2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M201.58 160.043V159.127H204.066V160.043C204.066 160.247 203.984 160.442 203.84 160.587C203.696 160.731 203.5 160.812 203.296 160.812H202.396C202.191 160.812 201.996 160.731 201.851 160.587C201.707 160.442 201.626 160.247 201.626 160.043H201.58Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_403_46089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.058 160.851L204.065 160.774V160.851H204.058Z",
    fill: "#ECEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.996 160.851L204.065 160.297V160.774L204.058 160.851H203.996Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.935 160.851L204.065 159.82V160.297L203.996 160.851H203.935Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.873 160.851L204.065 159.342V159.82L203.935 160.851H203.873Z",
    fill: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.812 160.851L204.027 159.142H204.065V159.342L203.873 160.851H203.812Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.75 160.851L203.965 159.142H204.027L203.812 160.851H203.75Z",
    fill: "#E9E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.688 160.851L203.912 159.142H203.966L203.75 160.851H203.688Z",
    fill: "#E8E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.627 160.851L203.842 159.142H203.911L203.688 160.851H203.627Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.565 160.851L203.781 159.142H203.842L203.627 160.851H203.565Z",
    fill: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.504 160.851L203.727 159.142H203.781L203.565 160.851H203.504Z",
    fill: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.442 160.851L203.665 159.142H203.727L203.504 160.851H203.442Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.38 160.851L203.604 159.142H203.665L203.442 160.851H203.38Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.319 160.851L203.542 159.142H203.604L203.38 160.851H203.319Z",
    fill: "#E4E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.257 160.851L203.481 159.142H203.542L203.319 160.851H203.257Z",
    fill: "#E3E2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.196 160.851L203.419 159.142H203.481L203.257 160.851H203.196Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.134 160.851L203.357 159.142H203.419L203.196 160.851H203.134Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.073 160.851L203.296 159.142H203.357L203.134 160.851H203.073Z",
    fill: "#E1E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.011 160.851L203.234 159.142H203.296L203.073 160.851H203.011Z",
    fill: "#E0DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.949 160.851L203.173 159.142H203.234L203.011 160.851H202.949Z",
    fill: "#DFDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.888 160.851L203.111 159.142H203.173L202.95 160.851H202.888Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.826 160.851L203.05 159.142H203.111L202.888 160.851H202.826Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.765 160.851L202.988 159.142H203.05L202.826 160.851H202.765Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.703 160.851L202.926 159.142H202.988L202.765 160.851H202.703Z",
    fill: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.642 160.851L202.865 159.142H202.926L202.703 160.851H202.642Z",
    fill: "#DBDADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58 160.851L202.804 159.142H202.865L202.642 160.851H202.58Z",
    fill: "#DAD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.526 160.851L202.742 159.142H202.803L202.58 160.851H202.526Z",
    fill: "#D9D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.465 160.851L202.68 159.142H202.742L202.526 160.851H202.465Z",
    fill: "#D8D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.403 160.851L202.619 159.142H202.68L202.465 160.851H202.403Z",
    fill: "#D7D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.342 160.851L202.557 159.142H202.619L202.403 160.851H202.342Z",
    fill: "#D6D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.28 160.851L202.495 159.142H202.557L202.341 160.851H202.28Z",
    fill: "#D5D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.219 160.851L202.434 159.142H202.496L202.28 160.851H202.219Z",
    fill: "#D4D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.157 160.851L202.372 159.142H202.434L202.219 160.851H202.157Z",
    fill: "#D3D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.095 160.851L202.311 159.142H202.372L202.157 160.851H202.095Z",
    fill: "#D2D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.034 160.851L202.249 159.142H202.311L202.095 160.851H202.034Z",
    fill: "#D1D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.972 160.851L202.188 159.142H202.249L202.034 160.851H201.972Z",
    fill: "#D0CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.911 160.851L202.126 159.142H202.188L201.972 160.851H201.911Z",
    fill: "#CFCECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.849 160.851L202.065 159.142H202.126L201.911 160.851H201.849Z",
    fill: "#CECDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.788 160.851L202.003 159.142H202.065L201.849 160.851H201.788Z",
    fill: "#CDCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.726 160.851L201.941 159.142H202.003L201.787 160.851H201.726Z",
    fill: "#CCCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.664 160.851L201.88 159.142H201.941L201.726 160.851H201.664Z",
    fill: "#CAC9CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.603 160.851L201.818 159.142H201.88L201.664 160.851H201.603Z",
    fill: "#C9C8C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.58 160.535L201.765 159.142H201.818L201.603 160.851H201.58V160.535Z",
    fill: "#C8C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.58 160.058L201.703 159.142H201.765L201.58 160.535V160.058Z",
    fill: "#C7C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.58 159.581L201.641 159.142H201.703L201.58 160.058V159.581Z",
    fill: "#C6C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.641 159.142L201.58 159.581V159.142H201.641Z",
    fill: "#C4C3C4"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M196.332 161.282C196.351 160.972 196.486 160.681 196.71 160.467C196.934 160.253 197.231 160.131 197.541 160.127C197.851 160.122 198.152 160.234 198.382 160.441C198.613 160.648 198.758 160.934 198.786 161.243L197.009 201.26L196.332 161.282Z",
    fill: "url(#paint10_linear_403_46089)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_403_46089",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 159,
    width: 3,
    height: 2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.301 160.051V159.135H198.786V160.051C198.786 160.255 198.705 160.45 198.561 160.595C198.416 160.739 198.221 160.82 198.017 160.82H197.116C197.011 160.826 196.906 160.811 196.808 160.775C196.709 160.739 196.618 160.684 196.542 160.612C196.466 160.54 196.405 160.453 196.363 160.356C196.322 160.26 196.3 160.156 196.301 160.051Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_403_46089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.779 160.851L198.786 160.774V160.851H198.779Z",
    fill: "#ECEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.717 160.851L198.786 160.297V160.774L198.779 160.851H198.717Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.656 160.851L198.786 159.82V160.297L198.717 160.851H198.656Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.594 160.851L198.786 159.343V159.82L198.656 160.851H198.594Z",
    fill: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.532 160.851L198.748 159.143H198.786V159.343L198.594 160.851H198.532Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.471 160.851L198.686 159.143H198.748L198.532 160.851H198.471Z",
    fill: "#E9E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.409 160.851L198.625 159.143H198.686L198.471 160.851H198.409Z",
    fill: "#E8E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.348 160.851L198.571 159.143H198.625L198.409 160.851H198.348Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.286 160.851L198.502 159.143H198.571L198.348 160.851H198.286Z",
    fill: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.225 160.851L198.448 159.143H198.502L198.286 160.851H198.225Z",
    fill: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.163 160.851L198.386 159.143H198.448L198.225 160.851H198.163Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.101 160.851L198.324 159.143H198.386L198.163 160.851H198.101Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.04 160.851L198.263 159.143H198.325L198.101 160.851H198.04Z",
    fill: "#E4E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.978 160.851L198.201 159.143H198.263L198.04 160.851H197.978Z",
    fill: "#E3E2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.917 160.851L198.14 159.143H198.201L197.978 160.851H197.917Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.855 160.851L198.078 159.143H198.14L197.917 160.851H197.855Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.793 160.851L198.017 159.143H198.078L197.855 160.851H197.793Z",
    fill: "#E1E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.732 160.851L197.955 159.143H198.017L197.793 160.851H197.732Z",
    fill: "#E0DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.67 160.851L197.894 159.143H197.955L197.732 160.851H197.67Z",
    fill: "#DFDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.609 160.851L197.832 159.143H197.894L197.67 160.851H197.609Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.547 160.851L197.771 159.143H197.832L197.609 160.851H197.547Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.486 160.851L197.709 159.143H197.771L197.547 160.851H197.486Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.424 160.851L197.647 159.143H197.709L197.486 160.851H197.424Z",
    fill: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.363 160.851L197.586 159.143H197.647L197.424 160.851H197.363Z",
    fill: "#DBDADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.301 160.851L197.524 159.143H197.586L197.363 160.851H197.301Z",
    fill: "#DAD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.24 160.851L197.463 159.143H197.524L197.301 160.851H197.24Z",
    fill: "#D9D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.186 160.851L197.401 159.143H197.463L197.239 160.851H197.186Z",
    fill: "#D8D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.116 160.851L197.339 159.143H197.401L197.185 160.851H197.116Z",
    fill: "#D7D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.062 160.851L197.278 159.143H197.34L197.116 160.851H197.062Z",
    fill: "#D6D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.001 160.851L197.216 159.143H197.278L197.063 160.851H197.001Z",
    fill: "#D5D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.939 160.851L197.155 159.143H197.216L197.001 160.851H196.939Z",
    fill: "#D4D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.878 160.851L197.093 159.143H197.155L196.939 160.851H196.878Z",
    fill: "#D3D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.816 160.851L197.032 159.143H197.093L196.878 160.851H196.816Z",
    fill: "#D2D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.755 160.851L196.97 159.143H197.032L196.816 160.851H196.755Z",
    fill: "#D1D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.693 160.851L196.909 159.143H196.97L196.755 160.851H196.693Z",
    fill: "#D0CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.632 160.851L196.847 159.143H196.909L196.693 160.851H196.632Z",
    fill: "#CFCECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.57 160.851L196.785 159.143H196.847L196.631 160.851H196.57Z",
    fill: "#CECDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.508 160.851L196.724 159.143H196.785L196.57 160.851H196.508Z",
    fill: "#CDCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.447 160.851L196.662 159.143H196.724L196.508 160.851H196.447Z",
    fill: "#CCCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.385 160.851L196.601 159.143H196.662L196.447 160.851H196.385Z",
    fill: "#CAC9CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.324 160.851L196.539 159.142H196.601L196.385 160.851H196.324Z",
    fill: "#C9C8C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.301 160.535L196.478 159.142H196.539L196.324 160.851H196.301V160.535Z",
    fill: "#C8C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.301 160.058L196.424 159.142H196.478L196.301 160.535V160.058Z",
    fill: "#C7C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.301 159.581L196.362 159.142H196.424L196.301 160.058V159.581Z",
    fill: "#C6C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.362 159.142L196.301 159.581V159.142H196.362Z",
    fill: "#C4C3C4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_403_46089",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.442 219.072) scale(198.442)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397EBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924582,
    stopColor: "#0E121D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_403_46089",
    x1: 200.966,
    y1: -1.07675,
    x2: 197.707,
    y2: 371.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#2995C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#278CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#216F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1C5675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#174159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#132F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#102232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0D1320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D121E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_403_46089",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.296 145.194) scale(177.137 145.194)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E6C",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D121E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_403_46089",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.588 137.081) scale(102.822 84.2805)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FF956C",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080D1C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_403_46089",
    x1: 202.946,
    y1: 69.0321,
    x2: 200.459,
    y2: 353.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00504775,
    stopColor: "#2995C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0587882,
    stopColor: "#278CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13337,
    stopColor: "#216F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1C5675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#174159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#132F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#102232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0E1927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0D1320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D121E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_403_46089",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.21 123.935) rotate(-90) scale(45.8963 45.8964)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_403_46089",
    x1: 200.141,
    y1: 141.989,
    x2: 176.569,
    y2: 141.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_403_46089",
    x1: 195.269,
    y1: 141.766,
    x2: 219.38,
    y2: 142.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_403_46089",
    x1: 200.041,
    y1: 131.115,
    x2: 199.887,
    y2: 122.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#754A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A6465C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CD4263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E84068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F93E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF3E6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_403_46089",
    x1: 201.344,
    y1: 159.774,
    x2: 202.281,
    y2: 209.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FD3E6C",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F73E6C",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ED3F6C",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#DD406C",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CA416C",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#B1436B",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#94456B",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#72476B",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4C496A",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D4C6A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_403_46089",
    x1: 196.064,
    y1: 159.77,
    x2: 196.991,
    y2: 209.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FD3E6C",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F73E6C",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ED3F6C",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#DD406C",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CA416C",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#B1436B",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#94456B",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#72476B",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4C496A",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D4C6A",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroPlanet);
export default __webpack_public_path__ + "static/media/hero_planet.36f67c9fd61985742bf9c0e1ff146641.svg";
export { ForwardRef as ReactComponent };